if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        /* Seth 2026-10-12 (Clarity: dead and rage taps on the full-screen photo): on phones a tap on a photo closes the
           viewer. Pinch zoom still works (a pinch is not a tap); videos and 3D models keep their own taps. */
        this.addEventListener('click', (event) => {
          if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
          const img = event.target.closest && event.target.closest('img');
          if (!img || img.closest('deferred-media, product-model, model-viewer, video')) return;
          if (!this.querySelector('[role="document"]').contains(img)) return;
          this.hide();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
